import { render, staticRenderFns } from "./SeriesAssignmentSection.vue?vue&type=template&id=294efd68&scoped=true&"
import script from "./SeriesAssignmentSection.vue?vue&type=script&lang=js&"
export * from "./SeriesAssignmentSection.vue?vue&type=script&lang=js&"
import style0 from "./SeriesAssignmentSection.vue?vue&type=style&index=0&id=294efd68&prod&lang=css&"
import style1 from "@assets/css/assignment_dates.css?vue&type=style&index=1&id=294efd68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294efd68",
  null
  
)

export default component.exports